import { defineStore } from "pinia";
import { ref } from "vue";

export const useAuthStore = defineStore("auth", () => {
  const isAuthenticated = ref(false);
  const isLoading = ref(true);
  const user = ref(null);

  function sync() {
    const store = window.klarnachrichten?.login?.app?.store;
    if (!store) { isLoading.value = false; return; }
    const auth = store.getState().auth;
    isAuthenticated.value = auth.isAuthenticated;
    isLoading.value = auth.isLoading;
    user.value = auth.user ?? null;
  }

  const fronteggStore = window.klarnachrichten?.login?.app?.store;
  if (fronteggStore) {
    fronteggStore.subscribe(sync);
  } else {
    isLoading.value = false;
  }
  sync();

  function login() {
    window.klarnachrichten?.login?.app?.loginWithRedirect({
      language: window.klarnachrichtenConfig?.locale || 'de',
    });
  }

  return { isAuthenticated, isLoading, user, login };
});
